import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CrisisState {
  isCrisisDetected: boolean;
  crisisChatId: string | null;
  tier: string | null;
  type: "chat" | "wellness" | string | null;
}

export const CRISIS_STORAGE_KEY = "crisisState";

if (typeof window !== "undefined") {
  try {
    localStorage.removeItem(CRISIS_STORAGE_KEY);
  } catch (error) {
    console.error("Error clearing crisis state from localStorage:", error);
  }
}

const initialState: CrisisState = {
  isCrisisDetected: false,
  crisisChatId: null,
  tier: null,
  type: null,
};

const crisisSlice = createSlice({
  name: "crisis",
  initialState,
  reducers: {
    setCrisisDetected(
      state,
      action: PayloadAction<{
        detected: boolean;
        chatId?: string | null;
        tier?: string | null;
        type?: "chat" | "wellness" | string;
      }>
    ) {
      state.isCrisisDetected = action.payload.detected;
      state.crisisChatId = action.payload.chatId || null;
      state.tier = action.payload.tier || null;
      state.type = action.payload.type || null;
    },
    resetCrisis(state) {
      state.isCrisisDetected = false;
      state.crisisChatId = null;
      state.tier = null;
      state.type = null;
    },
  },
});

export const { setCrisisDetected, resetCrisis } = crisisSlice.actions;
export default crisisSlice.reducer;
